<template>
  <div id="w_box">
    <Header :searchPage="searchPage" @goPage="goPage"></Header>
    <div class="content">
      <div class="con_w">
        <WhrSearch/>
        <div id="tab02" class="con act">
          <div class="tbl">
            <table>
              <colgroup>
                <col width="75">
                <col width="*">
                <col width="75">
                <col width="75">
                <col width="75">
                <col width="105">
                <col width="95">
                <col width="65">
                <col width="65">
                <col width="105">
              </colgroup>
              <thead>
                <tr>
                  <th scope="col" rowspan="2" class="tp fst">종목코드</th>
                  <th scope="col" rowspan="2" class="tp">종목명</th>
                  <th scope="col" rowspan="2" class="tp">기준</th>
                  <th scope="col" colspan="4" class="tp">EPS(USD)</th>
                  <th scope="col" colspan="3" class="tp lst">실적공시 발표 이후</th>
                </tr>
                <tr>
                  <th scope="col"><em>(잠정)</em>실적</th>
                  <th scope="col">컨센서스</th>
                  <th scope="col">
                    <select id="supVal" v-model="searchPage.supVal" @change="goSupPage()">
                      <option v-for="(option,index) in searchPage.supVals" v-bind:value="option.value" :key="index">{{option.text}}</option>
                    </select>
                  </th>
                  <th scope="col">실적공시일</th>
                  <th scope="col">경과일</th>
                  <th scope="col">수익률<em>(%)</em></th>
                  <th scope="col" class="lst">컨센변화율<em>(%)</em></th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(item,index) in searchPage.items">
                  <BrecordSub :item="item" :key="index"/>
                </template>
              </tbody>
            </table>
            <!-- //table -->
          </div>
          <!-- //tbl -->

          <Pagination :searchPage="searchPage" @goPage="goPage"/>
          <!-- //paging -->

          <div class="guide">
            * 어닝 판단 기준 : 희석주당순이익 컨센서스 대비 변화율 <br>
            * 출처 : EDGAR 실적공시(8-K, 10-Q, 10-K), GAAP기준 (Non-GAAP 확보시 우선 적용) <br>
            * 공시 규격 6-K의 ADR종목은 제공되지 않음
          </div>
          <!-- //guide -->

          <div class="time">
            한국시간 기준 {{ curTime }}
          </div>
          <!-- //time -->
        </div>
      </div>
   </div>
  </div>
</template>

<script>
import Header from '@/components/kiwoom/usRecord/pc/common/Header'
import WhrSearch from '@/components/kiwoom/usRecord/pc/common/WhrSearch'
import BrecordSub from '@/views/kiwoom/usRecord/pc/Brecord_sub'
import {mapGetters} from 'vuex'
import Pagination from '@/components/common/Pagination'
import axios from 'axios'
import { EventBus } from '@/store/event-bus'

export default {
  components: {
    Header,
    WhrSearch,
    BrecordSub,
    Pagination
  },
  data () {
    return {
      searchPage: {
        pageNo: 1,
        pageSize: 14,
        totalRows: 0,
        items: [],
        supVal: 'ALL',
        supVals: [
          {text: '전체', value: 'ALL'},
          {text: '어닝서프라이즈', value: 'supA'},
          {text: '예상수준상회', value: 'supB'},
          {text: '예상치부합', value: 'supC'},
          {text: '예상수준하회', value: 'supD'},
          {text: '어닝쇼크', value: 'supE'}
        ]
      },
      curTime: new Date().toLocaleString()
    }
  },
  methods: {
    init () {
      const params = {
        chkIndex: this.getUsRecordSettings.chkIndex,
        pageNo: this.searchPage.pageNo,
        pageSize: this.searchPage.pageSize,
        symbol: this.getUsRecordSettings.symbol,
        supVal: this.searchPage.supVal
      }
      this.$store.dispatch('setLodingBarSetting', true)

      let postUrl = 'https://security.thinkpool.com/api/us/kw/earning/getUsStockDataListAjax.do'
      axios.post(postUrl, params).then((res) => {
        if (res.data.resCode === '1') {
          this.searchPage.totalRows = res.data.resObj.totalRows
          this.searchPage.items = res.data.resObj.mlist
          this.curTime = new Date().toLocaleString()
        }

        this.$store.dispatch('setLodingBarSetting', false)
      })
    },
    goPage (pageNo) {
      this.searchPage.pageNo = parseInt(pageNo)
      this.init()
    },
    goSupPage () {
      this.searchPage.supVal = $('#supVal').val()
      this.goPage('1')
    },
    setSymbolDataReset () {
      localStorage.setItem('symbol', '')
      localStorage.setItem('syName', '')
      this.$store.dispatch('saveUsSymbolSetting', '')
      this.$store.dispatch('saveUsSyNameSetting', '')
    }
  },
  computed: {
    ...mapGetters(['getUsRecordSettings']),
    getChkIndex () {
      return this.getUsRecordSettings.chkIndex
    },
    getSymbol () {
      return this.getUsRecordSettings.symbol
    },
    getSyName () {
      return this.getUsRecordSettings.syName
    },
    getPageNo () {
      return this.searchPage.pageNo
    }
  },
  created () {
    if (this.getUsRecordSettings.chkIndex !== 'SYMBOL') {
      this.setSymbolDataReset()
    }

    this.goPage('1')

    EventBus.$on('pageNo', (val) => {
      this.searchPage.pageNo = val
    })
  },
  watch: {
    getChkIndex (val, oldVal) {
      if (val !== oldVal) {
        localStorage.setItem('chkIndex', val)
        if (val !== 'SYMBOL') {
          this.setSymbolDataReset()
        }
        this.goPage('1')
      }
    },
    getSymbol (val, oldVal) {
      if (val !== oldVal) {
        localStorage.setItem('symbol', val)
        this.goPage('1')
      }
    },
    getSyName (val, oldVal) {
      if (val !== oldVal) {
        localStorage.setItem('syName', val)
      }
    },
    getPageNo (val, oldVal) {
      if (val !== oldVal) {
        EventBus.$emit('pageNo', val)
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/kiwoom/usRecord/pc/Brecord.vue